<template>
  <aroma-component/>
</template>

<script>
import AromaComponent from '@/spa/components/board/aroma/BoardAroma';

export default {
  name: 'AromaPage',
  components: {
    AromaComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/contents/AromaPage.vue